<template>
  <div class="Aviso">
    <div class="libe_home_nav" v-if="scroll >= 88">
      <headNav :activeNav="'loan'"></headNav>
    </div>
    <div class="libe_home_wrap">
      <div class="libe_homenav" v-if="scroll < 88 ">
        <headNav :activeNav="'loan'"></headNav>
      </div>

      <div class="arrecredi_home_banner">

      </div>

      <div class="bigContent">
        <div style="width: 100%;">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane name="first">
              <span slot="label">Aviso de privacidad</span>
              <div class="arrecrediprivacidad_view">
                <div class="content">
                  <p><span style="font-weight: bold;">Fecha de actualización:</span> 28 de abril de 2026  </p>
                  <p>
                    De conformidad con la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (en adelante, la “Ley”), su Reglamento y los Lineamientos del Aviso de Privacidad publicados en el Diario Oficial de la Federación el 17 de enero de 2013, YOONA TECH, S.A. DE C.V., a través de su aplicación Arrecredi, pone a su disposición el presente Aviso de Privacidad y le informa sobre los siguientes términos y condiciones:
                  </p>
                  <p style="font-weight: bold;">I. Tratamiento de los Datos Personales</p>
                  <p>
                    YOONA TECH, S.A. DE C.V. (en adelante, YOONA) y su aplicación Arrecredi, con domicilio en Calle Tonalá 59, Roma Nte., Cuauhtémoc, 06700 Ciudad de México, CDMX, es responsable de la obtención, uso, divulgación, almacenamiento, acceso, manejo, aprovechamiento, transferencia o disposición de datos personales (en adelante, “Tratamiento”).
                  </p>
                  <p style="font-weight: bold;">II. Datos Personales sujetos a Tratamiento.</p>
                  <p>
                    YOONA recabará los datos personales necesarios para cumplir con su objeto social, políticas de prevención y detección de operaciones con recursos de procedencia ilícita, financiamiento al terrorismo y demás políticas corporativas. Estos datos podrán ser recopilados de manera directa (a través de ejecutivos, funcionarios, empleados o promotores) o indirecta (mediante asesores o comisionistas), utilizando medios remotos o locales de comunicación electrónica, óptica u otra tecnología, como:
                  </p>
                  <ul>
                    <li>
                      Nuestro portal web o aplicación.
                    </li>
                    <li>
                      Correo electrónico o postal.
                    </li>
                    <li>
                      Servicios en línea.
                    </li>
                    <li>
                      Vía telefónica.
                    </li>
                  </ul>
                  <p>
                    Los datos personales recabados podrán incluir, entre otros:
                  </p>
                  <p style="font-weight: bold;">1.Datos de Identificación</p>
                  <ul>
                    <li>
                      Nombre completo, estado civil, género, fecha de nacimiento, edad, país.
                    </li>
                    <li>
                      Identificación oficial vigente, RFC, CURP, Firma Electrónica Avanzada (FIEL).
                    </li>
                    <li>
                      Correo electrónico, datos académicos, características físicas (fotografías).
                    </li>
                  </ul>
                  <p style="font-weight: bold;">2.Datos Personales</p>
                  <ul>
                    <li>
                      Información laboral, salarios mensuales, día de cobro, nivel educativo.
                    </li>
                    <li>
                      Información bancaria (tipo de cuenta, número de tarjeta).
                    </li>
                  </ul>
                  <p style="font-weight: bold;">3. Datos Comerciales</p>
                  <ul>
                    <li>
                      Fuente de ingresos, actividades empresariales, experiencia profesional.
                    </li>
                  </ul>
                  <p style="font-weight: bold;">4. Datos Laborales</p>
                  <ul>
                    <li>
                      Actividad principal, tipo de empleo, ingresos mensuales, dirección del centro de trabajo.
                    </li>
                    <li>
                      Fecha de ingreso, cargo, nombre del jefe directo.
                    </li>
                  </ul>
                  <p style="font-weight: bold;">5. Datos de SMS</p>
                  <ul>
                    <li>
                      Los mensajes SMS de carácter financiero que tienes guardados en tu dispositivo —entre ellos figuran marcas de tiempo, números telefónicos y el propio contenido de los mensajes— no implican que se recojan datos de tus SMS que no sean de índole financiera, ni que su contenido sea compartido. Estos datos son tratados a través de modelos automatizados para valorar solicitudes de préstamo, y se incorporan a nuestros sistemas de gestión de riesgos con el objetivo de establecer si cumples con los requisitos para acceder a nuestros servicios financieros.
                    </li>
                    <li>
                      Los datos se transfieren a nuestro servidor https://arredata.arrecredi.net.
                    </li>
                    <li>
                      Nunca compartiremos sus datos con terceros sin su consentimiento.
                    </li>
                    <li>
                      Para eliminar sus datos, envíe una solicitud a .
                    </li>
                  </ul>
                  <p style="font-weight: bold;">6. Correo electrónico</p>
                  <ul>
                    <li>
                      se usará únicamente para la atención de consultas de los usuarios, con el fin de dar respuesta oportuna a sus preguntas y solicitudes. Mantendremos absoluta confidencialidad de sus datos personales y no los revelaremos en ningún caso a terceros.
                    </li>
                  </ul>
                  <p style="font-weight: bold;">7. Datos de Cónyuge o Concubina</p>
                  <ul>
                    <li>
                      Nombre completo, dirección, ocupación, teléfonos de contacto, estado civil, género, país, fecha de nacimiento.
                    </li>
                  </ul>
                  <p style="font-weight: bold;">8. Datos Bancarios o Patrimoniales</p>
                  <ul>
                    <li>
                      Institución bancaria, número de cuenta, CLABE, tipo de cuenta, sucursal.
                    </li>
                    <li>
                      Huella, foto y firma digital.
                    </li>
                  </ul>
                  <p style="font-weight: bold;">9. Datos de Ubicación</p>
                  <ul>
                    <li>
                      Información de ubicación aproximada de su dispositivo para gestionar solicitudes de préstamo y reducir riesgos.
                    </li>
                  </ul>
                  <p style="font-weight: bold;">10. Datos del Dispositivo</p>
                  <ul>
                    <li>
                      Modelo de hardware, RAM, identificadores únicos (IMEI, número de serie, SSAID, AAID), información SIM.
                    </li>
                  </ul>
                  <p style="font-weight: bold;">11. Almacenamiento (solo fotos de galería)</p>
                  <ul>
                    <li>
                      Acceso a la galería para seleccionar y cargar imágenes requeridas en la solicitud de préstamo.
                    </li>
                    <li>
                      Las fotos se almacenan cifradas por 1 año.
                    </li>
                    <li>
                      Para eliminar sus fotos, contacte a
                    </li>
                  </ul>
                  <p style="font-weight: bold;">12. Cámara / Información de Imagen</p>
                  <ul>
                    <li>
                      Permiso de cámara para tomar fotos de su documento de identidad y rostro en vivo.
                    </li>
                    <li>
                      No accedemos a su galería de imágenes.
                    </li>
                  </ul>
                  <p style="font-weight: bold;">13. Datos de Contactos</p>
                  <ul>
                    <li>
                      Nombre y número de teléfono para comunicación efectiva en caso de préstamos vencidos.
                    </li>
                  </ul>
                  <p style="font-weight: bold;">14. Permisos del Dispositivo</p>
                  <ul>
                    <li>
                      Información emitida tras la activación de permisos de SMS, ubicación, cámara y calendario.
                    </li>
                  </ul>
                  <p>
                    <span style="font-weight: bold;">Nota:</span>YOONA no recaba datos sensibles (origen racial, estado de salud, creencias religiosas, preferencias sexuales, etc.). Tampoco venderá sus datos personales ni los utilizará para publicidad dirigida.
                  </p>

                  <p style="font-weight: bold;">III. Finalidades del Tratamiento</p>
                  <p>
                    Los datos personales se utilizarán para:
                  </p>
                  <ul>
                    <li>
                      Verificar y confirmar su identidad.
                    </li>
                    <li>
                      Realizar análisis de riesgos.
                    </li>
                    <li>
                      Cumplir con obligaciones contractuales y regulatorias.
                    </li>
                    <li>
                      Mantener su información actualizada.
                    </li>
                    <li>
                      Formalizar contratos derivados de la relación comercial.
                    </li>
                    <li>
                      Validar identidad mediante medios biométricos y biográficos.
                    </li>
                  </ul>
                  <p style="font-weight: bold;">IV. Mecanismos para manifestar negativa al Tratamiento</p>
                  <p>
                    Si no está de acuerdo con este Aviso de Privacidad, tiene 5 días hábiles para manifestar su negativa al tratamiento de sus datos personales. Envíe un correo a  con el asunto “Negativa para el Tratamiento de Datos Personales” e incluya sus datos de identificación.
                  </p>

                  <p style="font-weight: bold;">V. Transferencia de Datos</p>
                  <p>YOONA podrá transferir sus datos personales a terceros, asegurándose de que estos respeten los términos de este Aviso. Los datos podrán ser transferidos a:  </p>
                  <ul>
                    <li>
                      Sociedades prestadoras de servicios (Trans Unión de México, Círculo de Crédito, etc.).
                    </li>
                    <li>
                      Autoridades mexicanas y extranjeras.
                    </li>
                    <li>
                      Incode Technologies, Inc. (validación de identidad).
                    </li>
                    <li>
                      Adjust GmbH (análisis de comportamiento de usuarios).
                    </li>
                  </ul>
                  <p>
                    Si no desea que sus datos sean transferidos, cierre su cuenta o envíe un correo a .
                  </p>

                  <p style="font-weight: bold;">VI. Derechos ARCO (Acceso, Rectificación, Cancelación y Oposición)</p>
                  <p>Usted puede ejercer sus derechos ARCO enviando una solicitud a  o presentándose en nuestras oficinas en Av. P.º de la Reforma 222, Juárez, Cuauhtémoc, 06600 Ciudad de México, CDMX </p>
                  <p style="font-weight: bold;">VII. Modificaciones al Aviso de Privacidad</p>
                  <p>
                    YOONA se reserva el derecho de modificar este Aviso de Privacidad.
                  </p>
                  <p style="font-weight: bold;">VIII. Revocación del Consentimiento</p>
                  <p>
                    Puede revocar su consentimiento en cualquier momento siguiendo el procedimiento descrito en la sección VI.
                  </p>
                  <p style="font-weight: bold;">IX. Atención de Quejas y Denuncias</p>
                  <p>
                    Si considera que sus derechos han sido vulnerados, puede acudir al Instituto Nacional de Transparencia, Acceso a la Información y Protección de Datos Personales (INAI).
                  </p>
                  <p style="font-weight: bold;">X. Contacto</p>
                  <p>Para dudas o aclaraciones, contáctenos:  </p>
                  <ul>
                    <li><span style="font-weight: bold;">Teléfono:</span>5594484815</li>
                    <li><span style="font-weight: bold;">Email:</span>  (respuesta en 2-3 días hábiles).</li>
                    <li><span style="font-weight: bold;">Horario:</span> Lunes a viernes 9:00-18:30, sábado y domingo 9:00-14:30. </li>
                  </ul>
                  <p>
                    Este Aviso de Privacidad está diseñado para garantizar la protección y el uso responsable de sus datos personales. Agradecemos su confianza en <span style="font-weight: bold;">YOONA TECH, S.A. DE C.V.</span> y Arrecredi.
                  </p>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="Términos y Condiciones" name="second">
              <div class="arrecrediprivacidad_view">
                <div class="content">
                  <p><span style="font-weight: bold;">Fecha de actualización: </span>7 de febrero de 2025</p>
                  <p>
                    YOONA TECH, S.A. DE C.V. (en lo sucesivo, "YOONA"), a través de su portal https://www.arrecredi.net (en adelante, "Página Web") y su aplicación móvil "Arrecredi" (disponible para dispositivos Android), establece los siguientes términos y condiciones (en adelante, "Términos") que regulan el uso de sus servicios. Al solicitar un préstamo, el usuario acepta:
                  </p>
                  <ul>
                    <li>
                      1. El Aviso de Privacidad para el tratamiento de sus datos personales.
                    </li>
                    <li>
                      2. Sujeción plena a estos Términos y Condiciones.
                    </li>
                  </ul>
                  <p>Los documentos mencionados están disponibles para consulta en la Página Web.</p>
                  <p style="font-weight: bold;">I. Alcance y Aplicación</p>
                  <p><span style="font-weight: bold;">1.Destinatarios:</span></p>
                  <ul>
                    <li>
                      Servicios dirigidos exclusivamente a personas físicas mexicanas con capacidad legal para contratar.
                    </li>
                    <li>
                      Servicios dirigidos exclusivamente a personas físicas mexicanas con capacidad legal para contratar.
                    </li>
                    <p><span style="font-weight: bold;">2.Ámbito Geográfico:</span></p>
                    <li>
                      Servicios válidos únicamente en territorio mexicano. El acceso desde otros países no implica autorización para su uso fuera de México.
                    </li>
                  </ul>
                  <p style="font-weight: bold;">II. Aceptación de los Términos</p>
                  <p>Al navegar en la Página Web, registrarse o utilizar la Aplicación, el usuario manifiesta su aceptación plena y vinculante de estos Términos. En caso de desacuerdo, deberá abstenerse de usar los servicios. </p>
                  <p style="font-weight: bold;">III. Uso del Servicio</p>
                  <p><span style="font-weight: bold;">1.Requisitos Técnicos</span></p>
                  <p>El usuario es responsable de contar con: </p>
                  <ul>
                    <li>
                      Hardware y software compatibles.
                    </li>
                    <li>
                      Conexión a internet estable.
                    </li>
                    <li>
                      Dispositivos actualizados para garantizar el funcionamiento óptimo.
                    </li>
                  </ul>
                  <p>
                    El acceso desde dispositivos móviles puede generar cargos por datos según el proveedor de red.
                  </p>
                  <p><span style="font-weight: bold;">2.Prohibiciones</span></p>
                  <p>Queda estrictamente prohibido:</p>
                  <ul>
                    <li>
                      Interferir en las funcionalidades de la Página Web o Aplicación.
                    </li>
                    <li>
                      Alterar bases de datos, información o sistemas asociados.
                    </li>
                  </ul>
                  <p style="font-weight: bold;">IV. Registro y Cuenta de Usuario</p>
                  <p><span style="font-weight: bold;">1. Creación de Cuenta</span></p>
                  <ul>
                    <li>
                      Requiere completar un formulario con datos personales (nombre, correo electrónico, etc.).
                    </li>
                    <li>
                      Opción de registro vinculado a redes sociales (si está habilitado).
                    </li>
                    <p><span style="font-weight: bold;">2. Confidencialidad</span></p>
                    <li>
                      El usuario es responsable de mantener la seguridad de su contraseña.
                    </li>
                    <li>
                      Toda operación realizada desde su cuenta se considerará autorizada por el titular.
                    </li>
                  </ul>
                  <p><span style="font-weight: bold;">3. Inhabilitación o Cancelación</span></p>
                  <p>YOONA podrá suspender o cancelar cuentas si el usuario:  </p>
                  <ul>
                    <li>
                      Incumple estos Términos.
                    </li>
                    <li>
                      Realiza actividades fraudulentas.
                    </li>
                    <li>
                      Proporciona información falsa o no verificable.
                    </li>
                  </ul>
                  <p>
                    El usuario puede cancelar su cuenta en cualquier momento, siempre que no existan deudas pendientes.
                  </p>
                  <p style="font-weight: bold;">V. Solicitud de Préstamo</p>
                  <p><span style="font-weight: bold;">1. Monto y Autorización: </span></p>
                  <ul>
                    <li>
                      Monto máximo inicial: $20,000.00 MXN.
                    </li>
                    <li>
                      Montos mayores dependerán del historial crediticio del usuario.
                    </li>
                  </ul>
                  <p><span style="font-weight: bold;">2. Notificación:  </span></p>
                  <ul>
                    <li>
                      El préstamo se considerará autorizado únicamente tras notificación formal por la Aplicación o Página Web.
                    </li>
                  </ul>
                  <p style="font-weight: bold;">VI. Obligaciones de Pago</p>
                  <p><span style="font-weight: bold;">1. Intereses y Plazos:  </span></p>
                  <ul>
                    <li>
                      CAT (Costo Anual Total): 36% sobre saldos insolutos.
                    </li>
                    <li>
                      Interés moratorio aplicable en caso de incumplimiento.
                    </li>
                  </ul>
                  <p><span style="font-weight: bold;">2. Plazos de Liquidación:  </span></p>
                  <ul>
                    <li>
                      Plazo mínimo: 8 días a partir de la disponibilidad del préstamo.
                    </li>
                    <li>
                      Plazo máximo: 90 días (según historial crediticio).
                    </li>
                  </ul>
                  <p><span style="font-weight: bold;">3. Métodos de Pago: </span></p>
                  <ul>
                    <li>
                      Transferencia electrónica o servicios autorizados por YOONA (listados en la Página Web).
                    </li>
                    <p style="font-weight: bold;">VII. Protección de Datos</p>
                    <li>
                      El usuario autoriza a YOONA a consultar su historial crediticio en Sociedades de Información Crediticia (SIC).
                    </li>
                    <li>
                      Vigencia de la autorización: 3 años o mientras subsista la relación jurídica.
                    </li>
                  </ul>
                  <p style="font-weight: bold;">VIII. Propiedad Intelectual</p>
                  <p><span style="font-weight: bold;">YOONA </span>conserva todos los derechos sobre: </p>
                  <ul>
                    <li>
                      La marca "Arrecredi".
                    </li>
                    <li>
                      Contenidos, software y sistemas de la Página Web y Aplicación.
                    </li>
                  </ul>
                  <p>Prohibido su uso, reproducción o explotación sin autorización escrita.  </p>
                  <p style="font-weight: bold;">IX. Modificaciones</p>
                  <p>
                    <span style="font-weight: bold;">YOONA </span>podrá actualizar estos Términos en cualquier momento. Las versiones actualizadas se publicarán en la Página Web o Aplicación. El usuario tiene 5 días hábiles para manifestar desacuerdo; de lo contrario, se entenderá su aceptación.
                  </p>
                  <p style="font-weight: bold;">X. Jurisdicción y Ley Aplicable</p>
                  <ul>
                    <li>
                      Regidos por las leyes mexicanas.
                    </li>
                    <li>
                      Jurisdicción exclusiva: Tribunales de la Ciudad de México.
                    </li>
                  </ul>
                  <p style="font-weight: bold;">XI. Contacto</p>
                  <ul>
                    <li>
                      Domicilio: Calle Versalles 15, Piso 1, Juárez, Cuauhtémoc, CDMX, CP 06600.
                    </li>
                    <li>
                      Email:
                    </li>
                    <li>
                      Horario: Lunes a viernes, 9:00 – 15:00 hrs.
                    </li>
                  </ul>
                  <p style="font-weight: bold;">Al utilizar la Página Web o la Aplicación, el usuario confirma haber leído, entendido y aceptado íntegramente estos Términos y Condiciones.</p>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <footPage></footPage>
  </div>
</template>

<script>

  import $ from 'jquery';
  import headNav from "@/components/headNav.vue";
  import footPage from "@/components/foot.vue";
  import "../components/scss/Aviso.scss";

  export default {
    name: "loan",
    components: { headNav, footPage },
    data() {
      return {
        scroll: 0,
        activeName: 'first',
      }
    },
    mounted(){
      document.documentElement.scrollTop = 0;
      window.addEventListener('scroll',this.handleScroll);
      if(this.$route.query.activeName){
        this.activeName = this.$route.query.activeName;
      }
      this.$nextTick(() => {
        $('.el-tabs__active-bar').css({
          width: '150px'
        })
      });


    },
    methods: {
      handleClick(tab, event){
        console.log(tab)
        console.log(event)
        this.$nextTick(() => {
          setTimeout(() => {
            $('.el-tabs__active-bar').css({
              width: '150px'
            })
          }, 100)
        });
      },
      handleScroll(){
        //或者使用document.querySelector('.class或者#id').scrollTop
        this.scroll = document.documentElement.scrollTop||document.body.scrollTop
      },
    },
    //销毁,否则跳到别的路由还是会出现
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
</script>

<style>
  .title p span {
    border-bottom: 3px solid #4e67f1;
  }
  .arrecredi_home_banner{
    width: 100%;
    height: 402px;
    position: relative;
    overflow: hidden;
    z-index: 2;
  }
  .bigContent .el-tabs__item{
    height: 58px;
    font-weight: bold;
    font-size: 32px;
    color: #262A48;
  }
  .bigContent .el-tabs__item:hover{
    color: #262A48;
  }
  .bigContent .el-tabs__active-bar{
    height: 3px;
    background: #262A48;
  }
  .bigContent .el-tabs__item.is-active{
    color: #262A48;
  }
  .bigContent .el-tabs__nav-wrap::after{
    height: 0;
  }
  #tab-first{
    width: 495px;
  }
  .arrecrediprivacidad_view{
    width: 100%;
    padding: 50px 0 0 0;
  }

  /* 移动端适配 */
  @media (max-width: 768px) {
    .bigContent {
      width: 100%;
      box-sizing: border-box;
      padding: 0 16px;
    }
    .bigContent .el-tabs__item {
      font-size: 18px;
      height: 48px;
      padding: 0 12px;
    }
    #tab-first {
      width: auto;
    }
    .arrecrediprivacidad_view {
      padding: 30px 16px 0 16px;
    }
    .arrecrediprivacidad_view .content {
      font-size: 14px;
      line-height: 22px;
    }
    .arrecrediprivacidad_view p,
    .arrecrediprivacidad_view li {
      margin-bottom: 12px;
    }
    .arrecredi_home_banner {
      height: 200px;
    }
  }
</style>

